import {
  getTheme
} from "../Utils";

export const PELEX_URL = "test.pelex.ucr.ac.cr";
export const AVATAI_URL = "avatai.ucr.ac.cr";
export const LOCAL_URL = "localhost";

export enum Paths {
  BASE = "/",
  ERROR = "/error",
  HOME = "/home",
  API = "/api/*",

  AUTO_LOGIN = "/autologin/*",
  LOGIN = "/login",
  LOGIN_FORM_EDI = "/EDIForm",
  LOGIN_FORM = "/loginForm",
  LOGIN_FORMD = "/loginDoE",

  SAT_SURVEY = "/SATSurvey",

  LOGIN_DEMO = "/loginDemo",


  ADMIN = "/admin",
  ADMIN_TESTS_ID = "/admin/tests/:id",
  ADMIN_CANDIDATES = "/admin/candidates",
  ADMIN_USERS = "/admin/users",
  ADMIN_JUDGES = "/admin/judges",
  ADMIN_GLOBAL_PROPERTIES = "/admin/glob_prop",

  CREATE_PDFS = "/certificates",

  TEACHER_LICENSES_INST = "/licenses/",
  TEACHER_LICENSES_INST_UNIBAND = "/licenses/band",
  TEACHER_CANDIDATES = "/teacher/candidates",

  TESTS_PUBLIC_ID = "/tests/:publicId/:candidateToken",
  TESTS_PUBLIC_ID_LOGIN = "/tests/:publicId/login",
  SPEECH_TEST = "/tests/speech",
  AUTOMATED_TEST = "/automatedTests/:skillType",
  HOME_START_TEST = "/home/:test",

  CANDIDATE_DETAIL_PUBLIC_ID = "/candidates/detail/:username/:publicId/:candidateToken",

  EDI_CANDIDATES = "/EDI/:group",
  PUBLIC_CANDIDATES = "/scandidates/:group",
  PUBLIC_CANDIDATES_INST = "/candidatesInst/:institution",


  //TODO: check
  //https://test.pelex.ucr.ac.cr/slicenses/ITSE
  PUBLIC_LICENSES_INST = "/slicenses/:institution",


  JUDGE_CANDIDATES = "/judge/candidates",

  AVATAI_INTRO = "/introduction",
  AVATAI_REGISTER = "/register",
  AVATAI_RESEND_EMAIL = "/recover",

  // Only usable before 30/04/2024, after that, redirect to an encripted link
  TEACHER_CANDIDATE_RESULT = "/teacher/candidateResult/:userId",
  EDI_CANDIDATE_RESULT = "EDI/candidateResult/:userId",
  PUBLIC_CANDIDATE_RESULT = "candidateResult/:userId",

  PUBLIC_LICENSE_RESULT = "licenseResult/:userId",
}

export enum CandidateStatus {
  INVITED = "INVITED",
  TEST_IN_PROGRESS = "TEST_IN_PROGRESS",
  TEST_COMPLETE = "TEST_COMPLETE"
}

export enum UserStatus {
  AVAILABLE = "AVAILABLE",
  RESERVED = "RESERVED",
  USED = "USED"
}

export enum TestType {
  ADAPTIVE = "ADAPTIVE",
  ADAPTIVE_3PL = "ADAPTIVE_3PL",
  ADAPTIVE_RASCH = "ADAPTIVE_RASCH",
  RANDOMIZE = "RANDOMIZED",
  LINEAR = "LINEAR",
}

export enum SkillType {
  READING = "READING",
  LISTENING = "LISTENING",
  SPEAKING = "SPEAKING",
  WRITING = "WRITING"
}

export enum QuestionType {
  MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
  COMPOSITION = "COMPOSITION",
  MULTIPLE_RESPONSE = "MULTIPLE_RESPONSE",
  SHORT_ANSWER = "SHORT_ANSWER",
  NUMERIC = "NUMERIC",
  SEQUENCE = "SEQUENCE",
  MATCHING = "MATCHING",
  FILL_IN_BLANKS = "FILL_IN_BLANKS",
  LIST_SELECTION = "LIST_SELECTION",
  HOTSPOT = "HOTSPOT",
  DRAG_AND_DROP = "DRAG_AND_DROP",
  LIKERT_SCALE = "LIKERT_SCALE"
}

export enum QuestionParameterKey {
  PREPARATION_TIME="PREPARATION_TIME",
  RESPONSE_TIME="RESPONSE_TIME",
  SEQUENTIAL_OPTIONS="SEQUENTIAL_OPTIONS",
  RESOURCE_ORIGIN="RESOURCE_ORIGIN",

  QUESTION_ORDER="QUESTION_ORDER",
  WEIGHT="WEIGHT",
  IRT_A="IRT_A",
  IRT_B="IRT_B",
  IRT_C="IRT_C",
  ADDITIONAL_RESOURCE="ADDITIONAL_RESOURCE",
  HOTSPOT_CLICK_RADIUS="HOTSPOT_CLICK_RADIUS"
}
export enum AnswerPropertyKey {
  ABILITY_ESTIMATE="ABILITY_ESTIMATE",
  AUDIO_TIMES_PLAYED="AUDIO_TIMES_PLAYED",
  SPEAKING_QUESTION_STARTED="SPEAKING_QUESTION_STARTED",
  WRITING_TEXT_ANSWER="WRITING_TEXT_ANSWER",
}

export enum EducationType {
  PRIMARY_INCOMPLETE = "PRIMARY_INCOMPLETE",
  PRIMARY_COMPLETE = "PRIMARY_COMPLETE",
  SECONDARY_INCOMPLETE = "SECONDARY_INCOMPLETE",
  SECONDARY_COMPLETE = "SECONDARY_COMPLETE",
  TECHNICAL = "TECHNICAL",
  DIPLOMAT = "DIPLOMAT",
  UNIVERSITY_INCOMPLETE = "UNIVERSITY_INCOMPLETE",
  UNIVERSITY_COMPLETE = "UNIVERSITY_COMPLETE",
  NONE = "NONE",
}

export enum Authority {
  ROLE_ADMIN = "ROLE_ADMIN",
  ROLE_TEACHER = "ROLE_TEACHER",
  ROLE_JUDGE = "ROLE_JUDGE",
}

export type AppFont = {
  weight: string;
  h1: string;
  h2: string;
  h3: string;
  h4: string;
  h5: string;
  h6: string;
  p: string;
  iconButton: string;
  iconButtonBox: string;
  endMsg: string;
iconButtonWidth: string;
  iconButtonHeight: string;
  buttonText: string;
  midHeading: string;

};
export const basicFont : AppFont= {
  weight: "normal",
  h1: "auto",
  h2: "auto",
  h3: "auto",
  h4: "auto",
  h5: "auto",
  h6: "auto",
  p: "auto",
  iconButton: "3rem",
  iconButtonBox: "4rem",
  endMsg: "3xl",
  iconButtonWidth: "5rem",
  iconButtonHeight: "4rem",
  buttonText: "auto",
  midHeading: "md",

};

export const bigFont : AppFont = {
  weight: "bold",
  h1: "2.7em",
  h2: "2.55em",
  h3: "2.45em",
  h4: "2.3em",
  h5: "1.9em",
  h6: "1.9em",
  p: "1.6em", //"1.5em",
  iconButton: "4.9rem",
  iconButtonBox: "6.5rem",
  endMsg: "4xl",
  iconButtonWidth: "10.5rem",
  iconButtonHeight: "6.5rem",
  buttonText: "2em",
  midHeading: "lg",
};

export type AppTheme = {
  BG: string;
  BG_SECONDARY: string;
  BG_HOME: string;
  COLOR_SCHEME: string;
  BG_INACTIVE: string;
  TEXT_PRIMARY: string;
  TEXT_SECONDARY: string;
  TEXT_ACCENT: string;
  SPECIAL_ACCENT: string;
  IMG_GRAYSCALE: string;
  IMG_CONTRAST: string;
  OUTLINE: string;
  LIGHT_BG: string;
  X_LIGHT_BG: string;
  SPECIAL_SCHEME: string;
};

export const basicTheme: AppTheme = {
  BG: "white",
  BG_SECONDARY: "#05569e", // blue
  BG_HOME: "rgba(6, 101, 183, 0.9)", // trans blue
  COLOR_SCHEME: "teal",
  BG_INACTIVE: "gray",
  TEXT_PRIMARY: "black",
  TEXT_SECONDARY: "white",
  TEXT_ACCENT: "#05579e", // blue
  SPECIAL_ACCENT:"#f6b024", // yellow
  OUTLINE:"inherit",
  IMG_GRAYSCALE: "0%",
  IMG_CONTRAST: "100%",
  LIGHT_BG: "gray.300",
  X_LIGHT_BG: "gray.100",
  SPECIAL_SCHEME: "yellow",
}

export const BWTheme: AppTheme = {
  BG: "white",
  BG_SECONDARY: "dimgray",
  BG_HOME: "rgba(10, 10, 10, 0.9)",
  COLOR_SCHEME: "blue",
  BG_INACTIVE: "gray",
  TEXT_PRIMARY: "black",
  TEXT_SECONDARY: "white",
  TEXT_ACCENT: "black",
  SPECIAL_ACCENT:"black",
  OUTLINE:"black",
  IMG_GRAYSCALE: "100%",
  IMG_CONTRAST: "150%",
  LIGHT_BG: "gray",
  X_LIGHT_BG: "gray.300",
  SPECIAL_SCHEME: "gray",
}

export const ValidImageFormats = ["jpg", "bmp", "png", "jpeg"]
export const ValidAudioFormats = ["mp3"]
export const ValidJsonTypes = ["json"]
export const ValidExcelTypes = ["xlsx", "xls", "odsl", "csv"]


export function customButtonProps(isAvatai: boolean) {
  const theme = getTheme();
  return {
  minW: "auto",
  borderWidth: isAvatai ? "3px" : "",
  borderRadius: isAvatai ? "100px" : "8px",
  borderColor: isAvatai ? 'blue' : "",
  variant: isAvatai ? 'outline' : "solid",
  colorScheme: isAvatai ? "blue" : theme.COLOR_SCHEME,
  color: isAvatai ? "black" : theme.TEXT_SECONDARY,
  }
};

export const whiteAvataiButtonProps = {
  borderWidth:"3px",
  borderRadius:"100px",
  borderColor:'blue',
  variant:'outline',
  background: 'white',
  minW:"auto",
};